import { useApiData } from "hooks/useApiData"
import { APIError } from "lib/api"

interface FeatureFlagsResponse {
  flag: string
  isActive: boolean
}

interface UseFeatureFlag {
  isFlagActive: boolean
  error?: APIError
  isLoading: boolean
  mutate: () => void
}

const useFeatureFlag = (flagName: string): UseFeatureFlag => {
  const { data, error, isLoading, mutate } = useApiData<FeatureFlagsResponse>(
    `feature-flags/${flagName}/`
  )

  return {
    isFlagActive:
      !isLoading &&
      (!error || Object.keys(error).length === 0) &&
      data?.isActive === true,
    error,
    isLoading,
    mutate
  }
}

export default useFeatureFlag
